<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-12-04 18:56:40
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-05-25 11:15:55
 -->
<template>
  <div class="headercontent">
    <header>
      <i class="iconfont icon-home_location_icon_l" @click="closeHandsel"></i>
      <p>{{headerMsg.title ? headerMsg.title : $route.meta.title}}</p>
    </header>
  </div>
</template>

<script>
export default {
  name: "h5Header",
  props: {
    headerMsg: Object //对象类型
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    closeHandsel() {
      // url有值时路由跳转
      if (this.headerMsg.url) {
        this.$router.go(-1);
        // this.$router.push({
        //   path: this.headerMsg.url
        //   //   query: {
        //   //     type: this.GetQueryString("type") || '',
        //   //     refereeId: this.GetQueryString("refereeId") || '',
        //   //     wx: this.GetQueryString("wx") || "1"
        //   //   }
        // }); //跳转
        return;
      }
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.closeHandsel();
        } else {
          // ios环境
          window.webkit.messageHandlers.closeHandsel.postMessage("");
        }
      }
    }
  },
  
};
</script>

<style lang="scss" scoped>
.headercontent {
  height: 44px;
  header {
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    z-index: 201;
    width: 100%;
    height: 44px;
    background: #fff;
    border-bottom: 1.04px solid #f0f0f0;
    i {
      font-size: 26px;
      position: absolute;
      left: 0;
      top: 8px;
      z-index: 88;
    }
    p {
      font-size: 18px;
      margin: 0;
      position: absolute;
      left: 0;
      right: 0;
      top: 10px;
      z-index: 87;
    }
  }
}
</style>

